import { render, staticRenderFns } from "./GroupsPrograms.vue?vue&type=template&id=6b924239&scoped=true&"
import script from "./GroupsPrograms.vue?vue&type=script&lang=ts&"
export * from "./GroupsPrograms.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b924239",
  null
  
)

export default component.exports